module.exports = __webpack_public_path__ + "img/kr.02c9912b.svg";